"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import type { ArtistPreviewTab } from "@/hooks/useArtistPreviewModal";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getTrophyArtworkCount } from "@/helpers/artist-activity.helpers";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ArtistPreviewAppWrapper from "./ArtistPreviewAppWrapper";
import { ArtistPreviewModalContent } from "./ArtistPreviewModalContent";
export type { ArtistPreviewTab as ModalTab };
interface ArtistPreviewModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly user: ApiProfileMin;
  readonly initialTab?: ArtistPreviewTab | undefined;
}
export const ArtistPreviewModal = t0 => {
  const $ = _c(44);
  const {
    isOpen,
    onClose,
    user,
    initialTab: t1
  } = t0;
  const initialTab = t1 === undefined ? "active" : t1;
  const {
    isApp
  } = useDeviceInfo();
  const [activeTab, setActiveTab] = useState(initialTab);
  const hasTrophyArtworks = getTrophyArtworkCount(user) > 0;
  let t2;
  let t3;
  if ($[0] !== initialTab || $[1] !== isOpen) {
    t2 = () => {
      if (isOpen) {
        setActiveTab(initialTab);
      }
    };
    t3 = [isOpen, initialTab];
    $[0] = initialTab;
    $[1] = isOpen;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== isApp || $[5] !== isOpen) {
    t4 = () => {
      if (isOpen && !isApp) {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
          document.body.style.overflow = originalOverflow;
        };
      }
    };
    t5 = [isOpen, isApp];
    $[4] = isApp;
    $[5] = isOpen;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  if (!isOpen) {
    return null;
  }
  if (isApp) {
    let t6;
    if ($[8] !== activeTab || $[9] !== hasTrophyArtworks || $[10] !== isOpen || $[11] !== onClose || $[12] !== user) {
      t6 = <ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={true} activeTab={activeTab} onTabChange={setActiveTab} hasTrophyArtworks={hasTrophyArtworks} />;
      $[8] = activeTab;
      $[9] = hasTrophyArtworks;
      $[10] = isOpen;
      $[11] = onClose;
      $[12] = user;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== isOpen || $[15] !== onClose || $[16] !== t6) {
      t7 = <ArtistPreviewAppWrapper isOpen={isOpen} onClose={onClose}>{t6}</ArtistPreviewAppWrapper>;
      $[14] = isOpen;
      $[15] = onClose;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    return t7;
  }
  let t6;
  if ($[18] !== onClose) {
    t6 = <Transition.Child as={Fragment} enter="tw-duration-200 tw-ease-out" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-duration-200 tw-ease-in" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-fixed tw-inset-0 tw-bg-iron-600/60" onClick={e => {
        e.stopPropagation();
        onClose();
      }} /></Transition.Child>;
    $[18] = onClose;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== onClose) {
    t7 = e_0 => {
      e_0.stopPropagation();
      onClose();
    };
    $[20] = onClose;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== activeTab || $[23] !== hasTrophyArtworks || $[24] !== isOpen || $[25] !== onClose || $[26] !== user) {
    t8 = <div className="tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-4"><Transition.Child as={Fragment} enter="tw-duration-0" enterFrom="tw-opacity-100" enterTo="tw-opacity-100" leave="tw-duration-0" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-100"><Dialog.Panel className="tw-relative tw-m-0 tw-max-h-[90vh] tw-w-full tw-max-w-5xl tw-overflow-hidden tw-rounded-xl tw-border tw-border-iron-800 tw-bg-iron-950 tw-p-0 tw-shadow-2xl tw-shadow-black/25" onClick={_temp2}><ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} activeTab={activeTab} onTabChange={setActiveTab} hasTrophyArtworks={hasTrophyArtworks} /></Dialog.Panel></Transition.Child></div>;
    $[22] = activeTab;
    $[23] = hasTrophyArtworks;
    $[24] = isOpen;
    $[25] = onClose;
    $[26] = user;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t7 || $[29] !== t8) {
    t9 = <div className="tw-fixed tw-inset-0 tw-z-[100] tw-hidden tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 sm:tw-block" onClick={t7}>{t8}</div>;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== activeTab || $[32] !== hasTrophyArtworks || $[33] !== isOpen || $[34] !== onClose || $[35] !== user) {
    t10 = <div className="tw-fixed tw-inset-0 tw-block tw-overflow-hidden sm:tw-hidden"><div className="tw-absolute tw-inset-0 tw-overflow-hidden"><div className="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-max-w-full tw-pt-10"><Transition.Child as={Fragment} enter="tw-transform tw-transition tw-duration-300 tw-ease-out" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-duration-300 tw-ease-in" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><Dialog.Panel className="tw-pointer-events-auto tw-relative tw-max-h-[90vh] tw-w-screen tw-transform-gpu tw-overflow-hidden tw-rounded-t-xl tw-border-t tw-border-iron-800 tw-bg-iron-950 tw-shadow-2xl tw-shadow-black/25 tw-will-change-transform"><ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} activeTab={activeTab} onTabChange={setActiveTab} hasTrophyArtworks={hasTrophyArtworks} /></Dialog.Panel></Transition.Child></div></div></div>;
    $[31] = activeTab;
    $[32] = hasTrophyArtworks;
    $[33] = isOpen;
    $[34] = onClose;
    $[35] = user;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t6 || $[39] !== t9) {
    t11 = <Dialog as="div" className="tw-relative tw-z-[9999] tw-cursor-default" onClose={_temp}>{t6}{t9}{t10}</Dialog>;
    $[37] = t10;
    $[38] = t6;
    $[39] = t9;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== isOpen || $[42] !== t11) {
    t12 = createPortal(<Transition.Root show={isOpen} as={Fragment}>{t11}</Transition.Root>, document.body);
    $[41] = isOpen;
    $[42] = t11;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  return t12;
};
function _temp() {}
function _temp2(e_1) {
  return e_1.stopPropagation();
}